import { CheckIcon } from "lucide-react";
import React from "react";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode;
  ariaLabel?: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
  className?: string; // Optional className prop for additional styling
}

function Checkbox(props: CheckboxProps) {
  const { label, ariaLabel, checked, onCheck, className, ...rest } = props;

  return (
    // The onClick only stops the parent card's click from also firing; the
    // <input> inside is the keyboard-operable control, so no key handler is owed.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
    <label
      className={`flex items-center gap-4 cursor-pointer px-2 py-2 -mx-2 rounded-lg transition-colors hover:bg-bg-brand-secondary-hover has-[:focus-visible]:bg-bg-brand-secondary-hover has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-[var(--focus-ring-default)] ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        {...rest}
        type="checkbox"
        checked={checked}
        className="peer sr-only"
        onChange={(e) => onCheck(e.target.checked)}
        aria-label={ariaLabel ?? (typeof label === "string" ? label : undefined)}
      />
      <div
        className={`w-[20px] h-[20px] rounded-[4px] border-[1.5px] 
          border-border-token-neutral-strong 
          bg-transparent flex items-center justify-center shrink-0
          text-fg-neutral-onFilled
          peer-checked:bg-bg-brand-primary-default 
          peer-checked:border-0 
          peer-hover:bg-bg-brand-secondary-hover
          peer-checked:peer-hover:bg-bg-brand-primary-hover 
          peer-active:border-border-token-brand-minimal
          peer-checked:peer-active:bg-bg-brand-primary-active
          `}
        tabIndex={-1}
        aria-hidden="true"
      >
        {checked && <CheckIcon size={18} className="text-fg-neutral-onFilled" aria-hidden="true" focusable="false" />}
      </div>
      <span
        className="text-fg-neutral-strong label-m-medium"
      >
        {label}
      </span>
    </label>
  );
}

export default Checkbox;
